// extracted by mini-css-extract-plugin
export default {"action-button":"DownloadButton_action-button__SLfjI","spinner":"DownloadButton_spinner__YcYkr","has-activity":"DownloadButton_has-activity__OPx0G"};